import {Vue} from 'ui.vue';
import '../../authorization.sass';
import BasicInput from '../../../common/basic-input/src/basic-input';
import Autocomplete from '../../../common/autocomplete/src/autocomplete';
import Modal from '../../../common/modal/src/modal';
import Agreement from '../../agreement/src/agreement';
import {validation} from '../../../helpers/input-validation';
import MaskedPhone from '../../../common/masked-phone/src/masked-phone';
import axios from 'axios';

Vue.component('reg', {
	data() {
		return {
			errors: [],
			showError: {
				message: '',
				modal: false
			},
			showSuccess: false,
			step: 1,
			confirmationCode: '',
			inputData: {
				lastName: {
					type: 'lastName',
					value: '',
					error: '',
				},
				name: {
					type: 'name',
					value: '',
					error: '',
				},
				dealer: {
					type: '',
					value: '',
					error: '',
				},
				login: {
					type: 'login',
					value: '',
					error: '',
				},
				phone: {
					type: 'phone',
					value: '',
					error: '',
				},
				agreement: {
					type: 'agreement',
					value: false,
					error: '',
				}
			},
			finalData: {
				postalCode: {
					type: 'postal',
					value: '',
					error: '',
				},
				region: {
					type: 'region',
					value: '',
					error: '',
				},
				city: {
					type: 'requiredCity',
					value: '',
					error: '',
				},
				address: {
					type: 'requiredAddress',
					value: '',
					error: '',
				},
				password: {
					type: 'password',
					value: '',
					error: '',
				},
				confirm: {
					type: 'confirm',
					value: '',
					error: '',
				}
			},
			seconds: 0
		};
	},

	template: `
		<div class="login">
			<div class="login__wrapper">
				<div class="login__left-side">
					<a class="login__logo-link" href="/">
						<img class="login__logo" src="/sources/img/logo-white.svg" alt="logo">
					</a>
					<h3 class="login__form-title desktop">Присоединитесь к&nbsp;команде профессионалов</h3>
					<p class="login__form-description desktop">Регистрируйтесь и находите клиентов еще быстрее вместе с нашим сервисом</p>
					<img class="login__desktop-image" src="/sources/img/login-desktop.png" alt="logo">
				</div>
				<div v-if="!TECE.DISABLE_REGISTER" class="login__form-wrapper login__form-wrapper--reg">
					<a class="login__logo login__logo--mobile" href="/">
						<img src="/sources/img/logo-white.svg" alt="logo">
					</a>
					<div class="login__form-text-wrapper login__form-text-wrapper--reg">
						<div class="login__form-type desktop">
							<h3>Регистрация</h3>
							<span class="login__step-counter">Шаг {{ step }} из 3</span>
						</div>
						<h3 class="login__form-title login__form-title--reg mobile">Присоединитесь к&nbsp;команде профессионалов</h3>
						<p class="login__form-description login__form-description--reg mobile">Регистрируйтесь и находите клиентов еще быстрее вместе с нашим сервисом</p>
					</div>
					<div class="login__form login__form--reg">
						<div class="login__form-type mobile">
							<h3>Регистрация</h3>
							<span class="login__step-counter">Шаг {{ step }} из 3</span>
						</div>
						<template v-if="step < 3">
							<div class="login__input-item-wrapper">
								<BasicInput :manualError="inputData.name.error" v-model="inputData.name.value" title="Имя*"/>
								<BasicInput :manualError="inputData.lastName.error" v-model="inputData.lastName.value" title="Фамилия*"/>
							</div>
							<BasicInput :manualError="inputData.dealer.error" v-model="inputData.dealer.value" title="Дилер основной"/>
							<div class="login__input-item-wrapper">
								<BasicInput :manualError="inputData.login.error" v-model="inputData.login.value" title="E-mail*" type="email"/>
								<MaskedPhone @input-number="changeNumber" :manualError="inputData.phone.error"/>
							</div>
						</template>
						<template v-if="step === 2">
							<div class="login__input-item-wrapper">
								<div class="login__sms-input">
									<p class="login__sms-input-description">Мы отправили Вам данные для входа. <br>Введите полученный код в следующее окно</p>
									<BasicInput v-model="confirmationCode" type="number" title="Код из смс"/>
									<div class="login__countdown-wrapper">
										<button
											v-if="seconds <= 0"
											class="login__resend-button"
											:class="{disabled: seconds > 0}"
											@click="resendSMS"
										>
											Выслать повторно
										</button>
										<p v-else class="login__countdown">Выслать код повторно можно через: {{ seconds }} сек</p>
									</div>
								</div>
							</div>
						</template>
						<template v-if="step === 3">
							<p class="login__address-text">Адрес будет использоваться для отправки сертификатов и сувениров.</p>
							<BasicInput :manualError="finalData.postalCode.error" title="Индекс" type="number" v-model="finalData.postalCode.value"/>
							<Autocomplete :needValidation="true" :manualError="finalData.city.error" @selected-city="changeCity"/>
							<BasicInput :manualError="finalData.address.error" title="Адрес" v-model="finalData.address.value"/>
							<h3 class="login__form-type login__form-type--create-password">Придумайте пароль</h3>
							<div class="login__input-item-wrapper">
								<BasicInput :manualError="finalData.password.error" title="Пароль*" type="password" v-model="finalData.password.value" autocomplete="new-password" id="new-password" />
								<BasicInput :manualError="finalData.confirm.error" title="Подтвердите пароль*" type="password" v-model="finalData.confirm.value" autocomplete="new-password" id="new-password" />
							</div>
						</template>
						<div class="errors-block" v-if="errors && errors.length">
							<p v-for="error in errors">{{ error }}</p>
						</div>
						<div class="login__form-buttons login__form-buttons--reg" >
							<template v-if="step === 1">
								<Agreement v-model="inputData.agreement.value" :manualError="inputData.agreement.error"/>
								<button class="login__form-button login__form-button--sms" @click="primaryRegistration">Получить СМС</button>
							</template>
							<button @click="smsConfirmation" class="login__form-button login__form-button--next-step" v-if="step === 2" >Продолжить</button>
							<button @click="secondaryRegistration" class="login__form-button login__form-button--next-step" v-if="step === 3">Зарегистрироваться</button>
						</div>
					</div>
					<div class="login__additional-links">
						<span class="login__additional-text">Уже зарегистрированы?</span>
						<a href="/lk" class="login__additional-link">Войти</a>
					</div>
				</div>
				<div v-if="TECE.DISABLE_REGISTER" class="login__form-wrapper login__form-wrapper--reg">
				    <p class="modal-header" style="text-align:center;">Регистрация новых участников временно недоступна.
				    Приносим извинения за доставленные неудобства.</p>
				</div>
			</div>
			<Modal v-if="showSuccess" link="/">
				<template v-slot:body>
					<div class="modal-body__error">
						<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M50.5 88C71.2107 88 88 71.2107 88 50.5C88 29.7893 71.2107 13 50.5 13C29.7893 13 13 29.7893 13 50.5C13 71.2107 29.7893 88 50.5 88Z" fill="#FCC14B"/>
							<path fill-rule="evenodd" clip-rule="evenodd" d="M53.5 32V29H47.5V32V56V59H53.5V56V32ZM53.5 69C53.5 70.6569 52.1569 72 50.5 72C48.8431 72 47.5 70.6569 47.5 69C47.5 67.3431 48.8431 66 50.5 66C52.1569 66 53.5 67.3431 53.5 69Z" fill="white"/>
						</svg>
						<span>Ожидайте подтверждение регистрации на указанный адрес почты</span>
					</div>
				</template>
			</Modal>
			<Modal v-if="showError.modal" @close="showError.modal = false">
				<template v-slot:body>
					<div class="modal-body__error">
						<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M50.5 88C71.2107 88 88 71.2107 88 50.5C88 29.7893 71.2107 13 50.5 13C29.7893 13 13 29.7893 13 50.5C13 71.2107 29.7893 88 50.5 88Z" fill="#FCC14B"/>
							<path fill-rule="evenodd" clip-rule="evenodd" d="M53.5 32V29H47.5V32V56V59H53.5V56V32ZM53.5 69C53.5 70.6569 52.1569 72 50.5 72C48.8431 72 47.5 70.6569 47.5 69C47.5 67.3431 48.8431 66 50.5 66C52.1569 66 53.5 67.3431 53.5 69Z" fill="white"/>
						</svg>
						<span>{{ showError.message }}</span>
					</div>
				</template>
			</Modal>
			</div>
		</div>
	`,

	methods: {
		changeNumber(value) {
			this.inputData.phone.value = value;
		},

		primaryRegistration() {
			let nextStepAllowed = true;
			Object.values(this.inputData).forEach(field => {
				field.error = validation(field);
				if (field.error) {
					nextStepAllowed = false;
				}
			});

			if (nextStepAllowed) {
				const requestData = {
					app: 'smsSenderReg',
					data: {
						EMAIL: this.inputData.login.value,
						LOGIN: this.inputData.login.value,
						LAST_NAME: this.inputData.lastName.value,
						NAME: this.inputData.name.value,
						PERSONAL_PHONE: this.inputData.phone.value,
						UF_MONTAJ_DILLER: this.inputData.dealer.value
					}
				};
				axios.post('/rest/', requestData)
					.then(response => {
						if(response.data.result.result) {
							this.step = 2;
							this.seconds = 59;
							this.startTimer();
							this.userId = response.data.result.user_id;
						} else {
							this.showError.message = response.data.result.message;
							this.showError.modal = true;
						}
					});
			}
		},

		startTimer() {
			if(this.seconds) {
				return setTimeout(() => {
					this.seconds--;
					this.startTimer();
				}, 1000);
			}
		},

		changeCity(location) {
			this.finalData.city.value = location.data.city_with_type;
			this.finalData.region.value = location.data.region_with_type;
		},

		smsConfirmation() {
			let requestData = {
				app: 'smsConfirm',
				data: {
					USER_ID: this.userId,
					CODE: this.confirmationCode
				}
			};
			axios.post('/rest/', requestData)
				.then(response => {
					if(response.data.result.result === true) {
						this.step = 3;
					} else {
						this.showError.modal = true; this.showError.message = 'Введён неверный код';
					}
				});
		},

		resendSMS() {
			if(this.seconds > 0) {
				return;
			}
			let requestData = {
				app: 'smsSenderRepeat',
				data: {
					user_id: this.userId
				}
			};
			axios.post('/rest/', requestData)
				.then(response => {
					if(response.data.result.result === true) {
						this.seconds = 59;
						this.startTimer();
					} else {
						const message = {
							RESULT: 'error',
							MESSAGE: ['Произошла ошибка'],
						};
						// eslint-disable-next-line no-undef
						BX.Vue.event.$emit('triggerError', message);
					}
				});
		},

		secondaryRegistration() {
			let nextStepAllowed = true;
			Object.values(this.finalData).forEach(field => {
				field.error = validation(field);
				if (field.error) {
					nextStepAllowed = false;
				}
			});

			if(this.finalData.password.value !== this.finalData.confirm.value) {
				this.finalData.confirm.error = 'Пароли не совпадают';
				nextStepAllowed = false;
			}

			if (nextStepAllowed) {
				let requestData = {
					app: 'userRegist',
					data: {
						USER_ID: this.userId,
						PERSONAL_STREET: this.finalData.address.value,
						PERSONAL_CITY: this.finalData.city.value,
						PERSONAL_STATE: this.finalData.region.value,
						PERSONAL_ZIP: this.finalData.postalCode.value,
						PASSWORD: this.finalData.password.value
					}
				};
				axios.post('/rest/', requestData)
					.then(response => {
						if(response.data.result.result) {
							this.showSuccess = true;
						} else {
							this.showError.message = response.data.result.message;
							this.showError.modal = true;
						}
					});
			}
		},
	},

	components: {
		BasicInput: BasicInput,
		Autocomplete: Autocomplete,
		Modal: Modal,
		Agreement: Agreement,
		MaskedPhone: MaskedPhone
	}
});

Vue.create({
	el: 'Reg',
	template: '<reg/>'
});
